/**
 * „Zuletzt angesehen" — speichert die zuletzt vom Besucher geöffneten Inserate
 * lokal im Browser (localStorage), funktioniert ohne Login. Wird auf der
 * Homepage als persönlicher „Zuletzt angesehen"-Bereich angezeigt.
 */
const KEY = "tw_recently_viewed";
const MAX = 10;

export function getRecentlyViewed() {
    try {
        const raw = localStorage.getItem(KEY);
        return raw ? JSON.parse(raw) : [];
    } catch {
        return [];
    }
}

export function addRecentlyViewed(listing) {
    if (!listing || !listing.id) return;
    try {
        // Trim images to keep the localStorage footprint small while still
        // rendering a full ListingCard.
        const slim = { ...listing, images: (listing.images || []).slice(0, 2) };
        delete slim.description;
        const prev = getRecentlyViewed().filter((x) => x.id !== listing.id);
        const next = [slim, ...prev].slice(0, MAX);
        localStorage.setItem(KEY, JSON.stringify(next));
    } catch {
        /* quota / serialization errors are non-fatal */
    }
}
